import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import EditableToggle from './EditableToggle';

const EditableTextbox = ({
  onChange,
  value = null,
  submitOnBlur = true,
  inputClassName = '',
  readOnly = false,
  placeholder = '',
  displayValue = null,
  displayClassName = '',
  ...rest
}) => (
  <EditableToggle
    onSubmit={onChange}
    value={value}
    readOnly={readOnly}
    displayValue={displayValue}
    className={displayClassName}
  >
    {({ inputValue, handleChange, inputRef, submit, cancel, handleKeyDown }) => (
      <input
        value={inputValue === null ? '' : inputValue}
        onChange={handleChange}
        ref={inputRef}
        onBlur={submitOnBlur ? submit : cancel}
        onKeyDown={handleKeyDown}
        className={classnames('form-control', inputClassName)}
        placeholder={placeholder}
        autoComplete="off"
        {...rest}
      />
    )}
  </EditableToggle>
);

EditableTextbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  submitOnBlur: PropTypes.bool,
  placeholder: PropTypes.string,
  inputClassName: PropTypes.string,
  displayClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  displayValue: PropTypes.node,
};

export default EditableTextbox;
